<template>
  <div>
    <div class="c-popup__back-black" v-on:click="closePopup()"></div>
    <div class="c-popup__window">
      <div class="c-popup__close" v-on:click="closePopup()">
        <span></span>
        <span></span>
      </div>
      <div
        class="c-popup__inner"
        :class="
          'c-popup__box_txt-' + (confirmTxtColor ? confirmTxtColor : 'red')
        "
      >
        <div class="c-popup__box_txt01">ヘルプコール</div>
        <div class="c-popup__box_txt03" v-html="confirmTxt"></div>
        <div class="c-popup_button_wrap">
          <div
            class="c-button c-button-green c-popup_button02"
            v-on:click="execLineBtn()"
          >
            LINE
          </div>
          <div
            class="c-button c-button-blue c-popup_button02"
            v-on:click="execTellBtn()"
          >
            電話
          </div>
          <div
            class="c-button c-button-black c-popup_button02"
            v-on:click="execCancelBtn()"
          >
            取り消し
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HelpCallPopupComponent",
  props: {
    confirmTxt: {
      required: true,
    },
    confirmTxtColor: {
      required: false,
    },
    buttonTxt: {
      required: true,
    },
    buttonLineClick: {
      type: Function,
      required: true,
    },
    buttonTellClick: {
      type: Function,
      required: true,
    },
    buttonCancelClick: {
      type: Function,
      required: true,
    },
    cancelClick: {
      type: Function,
      required: false,
    },
    buttonColor: {
      required: false,
    },
  },
  data: function () {
    return {
      message: "",
    };
  },
  methods: {
    /**
     * 登録処理呼び出し
     */
    execLineBtn() {
      this.buttonLineClick();
    },
    execTellBtn() {
      this.buttonTellClick();
    },
    execCancelBtn() {
      this.buttonCancelClick();
    },
    closePopup() {
      this.cancelClick();
    },
  },
};
</script>
